import {intlFormatSingleMessage} from 'shared/IntlFormatMessage/utils/intlMesssageFormat';

const FormattedMessage = ({message, values}: {message: string; values?: Record<string, any> | undefined}) =>
  intlFormatSingleMessage(message, values);

export default FormattedMessage;
